import { Skeleton } from '@/components/skeleton/skeleton'

import { cn } from '@/lib/utils'

import { InactiveCasesWrapper } from './inactive-cases-wrapper'

export const InactiveCasesContentLoading = () => {
  return (
    <InactiveCasesWrapper>
      <Skeleton className={cn('h-4', 'w-[90px]')} />
    </InactiveCasesWrapper>
  )
}
